import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({ children, className = '', hover = false, onClick }) => {
  const hoverClass = hover ? 'hover:shadow-xl cursor-pointer transform hover:-translate-y-1' : '';
  
  return (
    <div
      onClick={onClick}
      className={`card ${hoverClass} ${className}`}
    >
      {children}
    </div>
  );
};

export default Card;
